var CudaLaunchCommon = require("../CudaLaunchCommon");
var VFSController = require("./VFSController");
var VFSDirectoryListView = require("./VFSDirectoryListView");
var VFSFileActionView = require("./VFSFileActionView");
var VFSModel = require("./VFSModel");
var LaunchAttributesController = require("attributes/LaunchAttributesController");
var AttributesDialog = require("attributes/AttributesDialog");
var NavigationManager = require("common/NavigationManager");
var RootController = require("common/RootController");
var VFSLayoutContainer = require("./VFSLayoutContainer");
var postal = require("common/PubSub");
var FileTransferManager = require("./FileTransferManager");
var FileTransferDialog = require("./FileTransferDialog");
var CreateFolderDialog = require("./CreateFolderDialog");
var RenameDialog = require("./RenameDialog");
var AuthenticationController = require("authentication/AuthenticationController");
var AuthenticationDialog = require("authentication/AuthenticationDialog");

var mobileInitFired = false;

var startup = function() {
    if (!CudaLaunch.NP || !mobileInitFired) {
        setTimeout(startup, 50);
    } else {
        sessionStorage.setObject("NP", CudaLaunch.NP);
        document.title = CudaLaunch.NP.title;

        // TODO there might be a better way to do this
        CudaLaunch.clientConfiguration.getLanguage = function() {
            return CudaLaunch.NP.lang || "en";
        };

        // TODO
        CudaLaunch.clientConfiguration.isTouch = function() {
            return false;
        };

        CudaLaunchCommon();

        if (CudaLaunch.NP.hostname) {
            App.setHostname(CudaLaunch.NP.hostname);
        }

        $(document).trigger("preframeworkready");
    }
};

module.exports = function(hasFileTransferDialog) {
    var storedNP = sessionStorage.getObject("NP");
    var requiresInit = !storedNP;

    if (!CudaLaunch.NP) {
        CudaLaunch.NP = storedNP;
    }

    $(document).on("preframeworkready", function() {
        $(document).trigger("frameworkready");
    });

    $(document).one("mobileinit", function() {
        // Stop jQuery Mobile from auto initializing. We will manually do this after any extra bits of the app have been configured
        $.mobile.autoInitializePage = false;

        mobileInitFired = true;
    });

    $(document).on("appinit", function() {
        var navManager = CudaLaunch.navManager = new NavigationManager();
        var rootController = new RootController(navManager, CudaLaunch.clientConfiguration);
        CudaLaunch.controllers["RootController"] = rootController;

        var vfsContentView = new VFSLayoutContainer(navManager, $("#vfsContent"));
        rootController.addContentView("vfs", vfsContentView);

        var directoryListiewParent = new VFSDirectoryListView();
        var directoryListiewChild = new VFSDirectoryListView();
        var fileActionView = new VFSFileActionView();
        var createFolderDialog = new CreateFolderDialog();
        var renameDialog = new RenameDialog();
        navManager.setInitialView(directoryListiewParent);

        var fileTransferDialog;

        if (hasFileTransferDialog) {
            fileTransferDialog = new FileTransferDialog();
        }
        var vfsController = new VFSController(new VFSModel(), new FileTransferManager(fileTransferDialog), directoryListiewParent, directoryListiewChild, fileActionView, createFolderDialog, renameDialog);
        rootController.addController(vfsController);

        CudaLaunch.controllers.LaunchAttributesController = new LaunchAttributesController(new AttributesDialog());
        rootController.addController(CudaLaunch.controllers.LaunchAttributesController);

        CudaLaunch.controllers.AuthenticationController = new AuthenticationController(new AuthenticationDialog());
        rootController.addController(CudaLaunch.controllers.AuthenticationController);

        $(document).one("appready", function() {
            postal.channel("VFSController").publish("launch-resource", {
                vfsId : CudaLaunch.NP.vfsId,
                name : CudaLaunch.NP.title,
                requiresInit : requiresInit,
                favourite : CudaLaunch.NP.favourite
            });

            // TODO move this out of here?
            postal.channel("FavouritesController").subscribe("set-resource-favourite-state", function(data) {
                var changes = [{
                    resourceId : data.id,
                    resourceTypeId : "network_place"
                }];

                var params = {changes : JSON.stringify(changes)};
                params["_method"] = !data.state ? "PUT" : "DELETE";

                $.ajax({
                    type : "POST",
                    url : "/sslvpn_api/resource/favorite",
                    data : params
                });
            });
        });
    });

    $.ajaxSetup({
        // Globally handle any 401 responses
        statusCode : {
            401 : function() {
                var session = CudaLaunch.serverConfiguration.getSession();

                if (session) {
                    console.info("401 returned from server");
                    CudaLaunch.controllers.RootController.showErrorDialog($.t("common::auth.expired.title"), false, undefined, function() {
                        $.event.trigger("userunauthenticated");
                        CudaLaunch.serverConfiguration.clearSession();
                    });
                }
            }
        }
    });

    startup();
};